import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  methods: {
    handleError(error) {
      const responseData = error && error.response ? error.response.data : null
      const errorData = responseData && responseData.error ? responseData.error : responseData
      let message = 'Terdapat permasalahan, harap hubungi developer !!'

      if (typeof errorData === 'string') {
        message = errorData
      } else if (errorData && errorData.parent && errorData.parent.sqlMessage) {
        message = errorData.parent.sqlMessage
      } else if (
        errorData
        && errorData.errors
        && errorData.errors.length
        && errorData.errors[0].message
      ) {
        message = errorData.errors[0].message
      } else if (errorData && errorData.message) {
        message = errorData.message
      } else if (error && error.message) {
        message = error.message
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Oops!',
          text: message,
          icon: 'CheckIcon',
          variant: 'danger',
        },
      },{
        position:'bottom-right'
      })

    }
  }
}